const THOUSAND = 1_000;
const MILLION = 1_000_000;
const BILLION = 1_000_000_000;
const DEFAULT_CURRENCY = "$";

const formatWithSuffix = (value, divisor, suffix, currency) => {
  const scaled = value / divisor;
  const rounded = Math.round(scaled * 10) / 10;
  const trimmed = Number.isInteger(rounded) ? `${rounded}` : `${rounded.toFixed(1)}`;
  return `${currency}${trimmed}${suffix}`;
};

export const formatCompactCurrency = (value, currency = DEFAULT_CURRENCY) => {
  const symbol = currency || DEFAULT_CURRENCY;
  if (value == null || Number.isNaN(value)) {
    return `${symbol}0`;
  }
  const abs = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (abs < THOUSAND) {
    return `${sign}${symbol}${Math.round(abs)}`;
  }
  if (abs < MILLION) {
    return `${sign}${formatWithSuffix(abs, THOUSAND, "K", symbol)}`;
  }
  if (abs < BILLION) {
    return `${sign}${formatWithSuffix(abs, MILLION, "M", symbol)}`;
  }
  return `${sign}${formatWithSuffix(abs, BILLION, "B", symbol)}`;
};
